<template>
  <AppModalEdit
    :value="value"
    @input="$emit('input', $event)"
    @clickExec="onSubmit"
    title="地点グループ一括登録"
    exec-button-text="一括登録"
  >
    <p>各行につき1つずつ地点グループ名を入力してください。</p>
    <p v-if="!isUpperLimit" class="caption grey--text">
      あと{{ remainingGroupCount }}個追加できます
    </p>
    <v-form ref="form" v-model="valid" @submit.prevent>
      <v-textarea
        @input="onTextChange"
        v-model="textValue"
        :rules="[rules.required, max, upperLimit]"
        :placeholder="`地点グループ名1\n地点グループ名2`"
        outline
        height="60vh"
        class="bulkInputArea"
      />
    </v-form>
  </AppModalEdit>
</template>

<script>
import {
  makeTemporaryId,
  SimulationLocationGroup,
  SimulationCustomLocationGroup,
  MenuSetting,
} from '@/models/Simulation'
import { mapActions } from 'vuex'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'SimulationContentDeliveryLocationGroupBulkAddModal',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    simulationLocationGroups: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      textValue: '',
      addedGroupCount: 0,
      currentCount: null,
    }
  },
  computed: {
    menuSetting() {
      return this.form.deliverySetting.menuSetting
    },
    radius() {
      return this.menuSetting.enableBulkSetting
        ? this.menuSetting.radius
        : SimulationCustomLocationGroup.DEFAULT_RADIUS
    },
    totalCount() {
      return this.currentCount + this.addedGroupCount
    },
    remainingGroupCount() {
      return MenuSetting.MAX_GROUP_LIMIT - this.totalCount
    },
    isUpperLimit() {
      return this.totalCount > MenuSetting.MAX_GROUP_LIMIT
    },
    rules() {
      return SimulationLocationGroup.validations
    },
    /**
     * グループ名の長さを検証するバリデーション
     * 改行で区切られた複数のグループ名を検証するのはUI側の事情であり
     * SimulationLocationGroupクラスの責務ではないと判断しUI側に実装
     * ※クラス側には単一クラスの長さを検証するバリデーションを実装
     */
    max() {
      const groups = this.valueToArray(this.textValue)
      const message = groups
        .map(groupName => SimulationLocationGroup.validations.max(groupName))
        .find(result => result !== true)
      return !message ? true : message
    },
    upperLimit() {
      return this.isUpperLimit
        ? MenuSetting.VALIDATION_MESSAGES.upperLimit
        : true
    },
  },
  watch: {
    totalCount(total, prevTotal) {
      // 登録数を減らす際はアラートを表示させない
      if (prevTotal > total) {
        return false
      }
      if (total > MenuSetting.MAX_GROUP_LIMIT) {
        this.$confirm(MenuSetting.VALIDATION_MESSAGES.upperLimit, {
          onlyOk: true,
          okText: '閉じる',
        })
      }
    },
  },
  created() {
    this.currentCount = this.menuSetting.currentGroupCount
  },
  methods: {
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    onTextChange(value) {
      const addedGroups = this.valueToArray(value)
      this.addedGroupCount = addedGroups.length
    },
    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false
      }

      const groupNames = this.valueToArray(this.textValue)
      const simulationLocationGroups = groupNames.map((name, i) => {
        return {
          id: makeTemporaryId(i),
          radius: this.radius,
          name,
          added: true,
        }
      })
      await this.simulationLocationGroups.addManyGroup(simulationLocationGroups)
      this.showSnackbar({
        type: snackbarType.SUCCESS,
        message: '地点グループを一括登録しました',
      })
      this.$emit('input', false)
    },
    valueToArray(value) {
      return value
        .trim()
        .split(/\n/)
        .filter(name => name.trim().length > 0)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-textarea.v-text-field--enclosed textarea {
  margin-top: 5px;
}
</style>
